import { Controller } from "@hotwired/stimulus"

// layout--embedded-content on <body> — page subtitle, help tooltips, more-info hints.
// Re-runs on turbo:load because page fragments change without replacing <body>.
export default class extends Controller {
  connect() {
    this.boundTurboLoad = () => this.#initPageUI()
    this.boundTurboBeforeCache = () => this.#teardownPageUI()
    this.boundTooltipClick = (event) => this.#handleTooltipClick(event)

    document.addEventListener("turbo:load", this.boundTurboLoad)
    document.addEventListener("turbo:before-cache", this.boundTurboBeforeCache)
    this.element.addEventListener("click", this.boundTooltipClick)

    this.#initPageUI()
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.boundTurboLoad)
    document.removeEventListener("turbo:before-cache", this.boundTurboBeforeCache)
    this.element.removeEventListener("click", this.boundTooltipClick)
    this.#teardownPageUI()
  }

  #initPageUI() {
    this.#updateSubtitle()
    this.#initTooltips()
    this.#initMoreInfo()
  }

  #teardownPageUI() {
    document.querySelectorAll(".tooltip[data-embedded-content-init]").forEach((tooltip) => {
      tooltip.querySelector(".expand-title")?.remove()
      tooltip.querySelector(".controls")?.remove()
      delete tooltip.dataset.embeddedContentInit
    })
    $(".more-info").each(function () {
      const $el = $(this)
      if ($el.data("tipsy")) $el.tipsy("hide")
    })
  }

  #updateSubtitle() {
    const nav = document.getElementById("nav")
    const subtitle = document.getElementById("page-subtitle")
    if (!subtitle) return

    if (nav?.innerHTML?.trim()) {
      $("#page-subtitle").hide()
    } else {
      $("#page-subtitle").fadeIn()
    }
  }

  #initTooltips() {
    document.querySelectorAll(".tooltip").forEach((tooltip) => {
      if (tooltip.dataset.embeddedContentInit) return
      tooltip.dataset.embeddedContentInit = "true"

      const expandTitle = document.createElement("div")
      expandTitle.className = "expand-title"
      expandTitle.textContent = "Expand tooltip"

      const controls = document.createElement("div")
      controls.className = "controls"

      const displayMode = document.createElement("div")
      displayMode.className = "display-mode"
      displayMode.title = "Hide/show tooltip"

      const positionMode = document.createElement("div")
      positionMode.className = "position-mode"
      positionMode.title = "Switch to side/content"

      controls.append(displayMode, positionMode)
      tooltip.prepend(controls)
      tooltip.prepend(expandTitle)

      this.#restoreTooltipState(tooltip)

      if (!tooltip.classList.contains("expanded") && !tooltip.classList.contains("minimized")) {
        tooltip.classList.add("expanded")
      }
    })
  }

  #initMoreInfo() {
    $(".more-info").tipsy({ gravity: "s" })
  }

  #handleTooltipClick(event) {
    const displayMode = event.target.closest(".tooltip .display-mode")
    if (displayMode) {
      const tooltip = displayMode.closest(".tooltip")
      this.#tooltipSwitchState(tooltip)
      this.#saveTooltipState(tooltip)
      return
    }

    const expandTitle = event.target.closest(".tooltip .expand-title")
    if (expandTitle) {
      const tooltip = expandTitle.closest(".tooltip")
      this.#tooltipExpand(tooltip)
      this.#saveTooltipState(tooltip)
      return
    }

    const positionMode = event.target.closest(".tooltip .position-mode")
    if (positionMode) {
      const tooltip = positionMode.closest(".tooltip")
      this.#tooltipSwitchPosition(tooltip)
      this.#saveTooltipState(tooltip)
    }
  }

  #tooltipSwitchState(tooltip) {
    if (tooltip.classList.contains("expanded")) {
      this.#tooltipMinimize(tooltip)
    } else {
      this.#tooltipExpand(tooltip)
    }
  }

  #tooltipSwitchPosition(tooltip) {
    if (tooltip.classList.contains("side")) {
      tooltip.classList.remove("side")
      tooltip.classList.add("no-margin-top")
    } else {
      tooltip.classList.add("side")
      tooltip.classList.remove("no-margin-top")
    }
  }

  #tooltipExpand(tooltip) {
    tooltip.classList.remove("minimized")
    tooltip.classList.add("expanded")
    $(tooltip).find(".content").show()
    $(tooltip).find(".expand-title").hide()
  }

  #tooltipMinimize(tooltip) {
    $(tooltip).find(".content").hide()
    tooltip.classList.remove("expanded")
    tooltip.classList.add("minimized")
    $(tooltip).find(".expand-title").show()
  }

  #saveTooltipState(tooltip) {
    const ttid = tooltip.id
    if (!ttid) return
    const isExpanded = tooltip.classList.contains("expanded")
    const isSide = tooltip.classList.contains("side")
    const state = `${isExpanded ? "1" : "0"}${isSide ? "1" : "0"}`
    $.cookie(ttid, state)
  }

  #restoreTooltipState(tooltip) {
    const ttid = tooltip.id
    if (!ttid) return
    const state = $.cookie(ttid)
    if (!state) return

    if (state.charAt(0) === "1") {
      this.#tooltipExpand(tooltip)
    } else {
      this.#tooltipMinimize(tooltip)
    }
    if (state.charAt(1) === "1") {
      tooltip.classList.add("side")
      tooltip.classList.remove("no-margin-top")
    } else {
      tooltip.classList.remove("side")
      tooltip.classList.add("no-margin-top")
    }
  }
}
